import React, { useEffect } from "react";
import SiteLayout from "./layout/SiteLayout";
import HomePage from "./pages/HomePage";

import BotTraderPage from "./pages/BotTraderPage";
import BuildingStrategiesPage from "./pages/BuildingStrategiesPage";
import StrategyDiscoveryPage from "./pages/StrategyDiscoveryPage";

import AboutPage from "./pages/AboutPage";
import JustenChartrandPage from "./pages/JustenChartrandPage";
import MarcoSchapiraPage from "./pages/MarcoSchapiraPage";

import SupportPage from "./pages/SupportPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import SubscriptionTermsPage from "./pages/SubscriptionTermsPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import CheckoutCancelPage from "./pages/CheckoutCancelPage";

import StratifyProPage from "./pages/StratifyProPage";
import ConnectBrokeragePage from "./pages/ConnectBrokeragePage";
import IntegrationsPage from "./pages/IntegrationsPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import AccountOverviewPage from "./pages/account/AccountOverviewPage";
import ProfileSecurityPage from "./pages/account/ProfileSecurityPage";
import SubscriptionBillingPage from "./pages/account/SubscriptionBillingPage";
import UsageBenefitsPage from "./pages/account/UsageBenefitsPage";
import PreferencesPage from "./pages/account/PreferencesPage";
import PrivacySupportPage from "./pages/account/PrivacySupportPage";
import DeletionStatusPage from "./pages/account/DeletionStatusPage";
import AccountNotFoundPage from "./pages/account/AccountNotFoundPage";

import useRoute from "./hooks/useRoute";
import { navigate } from "./lib/navigate";
import { AuthProvider } from "./auth/AuthProvider";

const REDIRECTS = {
  "/contact": "/support",
  "/education": "/",
  "/backtesting-app": "/bot-trader",
  "/strategy-alerts": "/bot-trader#notifications",
  "/strategy-wallet-alerts": "/bot-trader#notifications",
  "/backtesting-wallet": "/building-strategies",
  "/strategy-wallet-vs-backtesting": "/building-strategies",
  "/backtesting-results": "/building-strategies",
  "/strategy-wallet": "/building-strategies#saved-strategies",
  "/strategy-wallet-app": "/building-strategies#saved-strategies",
};

export default function App() {
  const route = useRoute();

  useEffect(() => {
    const hash = typeof window !== "undefined" ? window.location.hash || "" : "";
    if (hash.startsWith("#/education")) {
      navigate("/", { replace: true });
      return;
    }
    if (route.path === "/education") {
      navigate("/", { replace: true });
      return;
    }
    const dest = REDIRECTS[route.path];
    if (dest) navigate(dest, { replace: true });
  }, [route.path]);

  let page = null;

  if (route.path === "/education") page = <HomePage />;

  else if (
    route.path === "/bot-trader" ||
    route.path === "/backtesting-app" ||
    route.path === "/strategy-alerts" ||
    route.path === "/strategy-wallet-alerts"
  ) {
    page = <BotTraderPage />;
  } else if (
    route.path === "/building-strategies" ||
    route.path === "/backtesting-wallet" ||
    route.path === "/backtesting-results" ||
    route.path === "/strategy-wallet" ||
    route.path === "/strategy-wallet-app" ||
    route.path === "/strategy-wallet-vs-backtesting"
  ) {
    page = <BuildingStrategiesPage />;
  } else if (route.path === "/strategy-discovery") page = <StrategyDiscoveryPage />;

  else if (route.path === "/about" && route.slug === "justen-chartrand") page = <JustenChartrandPage />;
  else if (route.path === "/about" && route.slug === "marco-schapira") page = <MarcoSchapiraPage />;
  else if (route.path === "/about") page = <AboutPage />;

  else if (route.path === "/support" || route.path === "/contact") page = <SupportPage />;
  else if (route.path === "/privacy-policy") page = <PrivacyPolicyPage />;
  else if (route.path === "/terms-of-use") page = <TermsOfUsePage />;
  else if (route.path === "/eula") page = <TermsOfUsePage />;
  else if (route.path === "/refund-policy") page = <RefundPolicyPage />;
  else if (route.path === "/subscription-terms") page = <SubscriptionTermsPage />;

  else if (route.path === "/checkout/success") page = <CheckoutSuccessPage />;
  else if (route.path === "/checkout/cancel") page = <CheckoutCancelPage />;

  else if (route.path === "/connect-brokerage") page = <ConnectBrokeragePage />;
  else if (route.path === "/integrations") page = <IntegrationsPage />;

  else if (route.path === "/stratifypro") page = <StratifyProPage />;
  else if (route.path === "/pricing") page = <StratifyProPage />;

  else if (route.path === "/sign-in") page = <SignInPage />;
  else if (route.path === "/sign-up") page = <SignUpPage />;

  else if (route.unknownAccount) page = <AccountNotFoundPage />;
  else if (route.path === "/account") page = <AccountOverviewPage />;
  else if (route.path === "/account/profile") page = <ProfileSecurityPage />;
  else if (route.path === "/account/billing") page = <SubscriptionBillingPage />;
  else if (route.path === "/account/usage") page = <UsageBenefitsPage />;
  else if (route.path === "/account/preferences") page = <PreferencesPage />;
  else if (route.path === "/account/privacy") page = <PrivacySupportPage />;
  else if (route.path === "/account/deletion-status") page = <DeletionStatusPage />;

  else page = <HomePage />;

  return (
    <AuthProvider>
      <SiteLayout>{page}</SiteLayout>
    </AuthProvider>
  );
}
